import React from 'react'
import styled from 'styled-components'
import { AbstractConnector } from '@web3-react/abstract-connector'
import { Colors } from '../../constants'
import { logAmplitudeEvent, Wallet } from '../../utils'

type Props = {
  wallet: Wallet
  connect: (connector: AbstractConnector) => void
}

export function Wallet({ wallet, connect }: Props) {
  return (
    <WalletButton
      key={wallet.label}
      onClick={() => {
        connect(wallet.connector)
        logAmplitudeEvent('Wallet: Click Connect', {
          wallet: wallet.label,
        })
      }}
      disabled={!wallet.connector}
    >
      {wallet.label}
      <WalletIcon src={wallet.iconUrl}></WalletIcon>
    </WalletButton>
  )
}

const WalletButton = styled.button`
  padding: 24px 30px;
  position: relative;
  display: flex;
  outline: none;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  border: 0;
  background: none;

  &:hover {
    color: ${Colors.Hover};
  }

  &:after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    left: 20px;
    width: calc(100% - 40px);
    height: 1px;
    background-color: ${Colors.LighterGray};
  }

  &:last-child {
    &:after {
      display: none;
    }
  }
`

const WalletIcon = styled.img`
  width: 28px;
  height: 28px;
`
